import styled from '@emotion/styled';
import {colors} from 'ui/config';
import {Img as ImgUI} from 'ui';

export const Container = styled('div')({
  position: 'relative',
  dispaly: 'flex',
  flexDirection: 'column',
  width: 200,
  marginBottom: 32,
  marginRight: 16,
});

export const Description = styled('div')({
  backgroundColor: colors.white,
  padding: '20px 12px 28px',
  height: 121,
  minHeight: 121,
  maxHeight: 121,
});

export const TypeLabel = styled('p')({
  position: 'absolute',
  top: 0,
  left: 12,
  fontSize: 13,
  color: colors.white,
  backgroundColor: 'rgba(56, 40, 24, 0.6)',
  borderRadius: 15,
  padding: '6px 10px',
  width: 'max-content',
});

export const Img = styled(ImgUI)({
  width: 200,
  height: 194,
  objectFit: 'cover',
});
